import { useApplication } from './useApplications';
import type { TenantLevelLocal } from '../api/types/PlatformLocal';

export interface TenantLevelsSource {
    levels?: TenantLevelLocal[];
    applicationId?: string;
}

/**
 * Niveles de RECURSO de un tenant con prioridad: `tenant.levels` si vino poblado; si viene vacío/ausente
 * y hay `applicationId`, los de su APLICACIÓN. Sin ninguno de los dos, `undefined`.
 */
export function useResolvedTenantLevels(
    tenant: TenantLevelsSource | undefined,
): TenantLevelLocal[] | undefined {
    const tenantLevels = tenant?.levels;
    const applicationId = tenant?.applicationId;
    const needsApp = !tenantLevels?.length && !!applicationId;
    const { data: app } = useApplication(needsApp ? applicationId : undefined);
    return tenantLevels?.length ? tenantLevels : needsApp ? app?.levels : undefined;
}
